





















import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import TeamMembers from "@/components/team-view/team-members/TeamMembers.vue";
import ContactUs from "@/components/shared/contact-us/ContactUs.vue";
import {
  getLeadershipMembers,
  getSabMembers,
} from "@/resources/content/team.ts";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "Team",
  components: {
    TeamMembers,
    ContactUs,
    HeaderImg,
  },
  data() {
    return {
      sections: {
        teamLeadership: "team-leadership",
        teamSAB: "team-sab",
      },
      membersLeadership: <any>[],
      membersSAB: <any>[],
      teamHeaderImg: {
        path: "team",
        image: "",
        imageAlt: "team top img",
      },
    };
  },
  created() {
    this.membersLeadership = getLeadershipMembers();
    this.membersSAB = getSabMembers();
    this.teamHeaderContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();

    window.addEventListener("resize", () => this.teamHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => this.teamHeaderContent());
  },
  methods: {
    setRevealAnimation() {
      Object.entries(this.sections).forEach((section: string[]) => {
        ScrollReveal().reveal(`.${section[1]}`, scrollConfig);
      });
    },
    teamHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.teamHeaderImg = {
        ...this.teamHeaderImg,
        image: desktopViewport
          ? "desktop_team_top_img.jpg"
          : "mobile_team_top_img.jpg",
      };
    },
  },
});
